import { render, staticRenderFns } from "./SpinnerBottom.vue?vue&type=template&id=328d40d8&scoped=true&"
import script from "./SpinnerBottom.vue?vue&type=script&lang=js&"
export * from "./SpinnerBottom.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerBottom.vue?vue&type=style&index=0&id=328d40d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328d40d8",
  null
  
)

export default component.exports